import PaasComs from './components/business/paas'

import {
  SyRegion,
  SyFile,
  SyImage,
  SyPopup,
  ButtonGallery,
  ButtonGroup,
  Buttons,
  Currency,
  Number,
  ReadText,
  Tip,
  SyLink
} from './components/business/paas/components/index.js'

// 导入导出方法
import exportPower from './components/business/paas/components/basis/import-export/export-power'
import SyPaasImport from './components/business/paas/components/basis/import-export/import-tem.vue'

// 需求提报相关组件
import DemandDialogDetail from './components/business/demand-submission/detail/dialog.vue'
import DemandPageDetail from './components/business/demand-submission/detail/page.vue'
import DemandDetailForTable from './components/business/demand-submission/detail-for-table/index.vue'
import DemandDialogEdit from './components/business/demand-submission/edit/dialog.vue'
import DemandPageEdit from './components/business/demand-submission/edit/page.vue'
import DemandPurchaseCategoryConfirm from './components/business/demand-submission/purchase-category-confirm/index.vue'

// 新建/编辑/详情/列表 组件
import PaasList from './components/business/paas/pages/list/index.vue'
import PaasDetail from './components/business/paas/pages/detail/detail.vue'
import PaasEdit from './components/business/paas/pages/edit/index.vue'

// 公共基础组件
import SyForm from './components/basis/fe-form/form.vue'
import SyFormItem from './components/basis/fe-form/form-item.vue'
import Group from './components/basis/group/index.vue'
import ListSearch from './components/basis/list-search-2/index.vue'
import ListSearchItem from './components/basis/list-search-item-2/index.vue'
import Tabs from './components/basis/tabs-2/index.vue'
import TabsPane from './components/basis/tab-pane/index.vue'
import Tree from './components/basis/tree'
import TreeSelector from './components/basis/tree-selector'

// 公共业务组件
import CurrencyText from './components/business/multi-currency/currency-text/index'

// layoutTab
import LayoutTab from './components/business/layout-tab/index.vue'

import BudgetSubjectTreeSelector from './components/business/budget-subject-tree-selector/index'
import PurLineTypeEdit from './components/business/pur-line-type/edit/index'
import PurLineTypeDetail from './components/business/pur-line-type/detail/index'
import ReassignmentDialog from './components/business/reassignment-dialog/index.vue'
import TaxRate from './components/business/tax-rate/index'
import Unit from './components/business/unit/index'
import RegionTreeCascade from './components/business/region-tree-cascade/index'
import StepImport from './components/business/step-import/index.vue'
import SyImport from './components/business/sy-import/index.vue'
import TinymceEditorExtend from './components/business/tinymce-editor-extend/index.vue'

// 全局引入
const components = {
  CurrencyText,
  SyForm,
  SyFormItem,

  // 公共基础组件
  Group,
  ListSearch,
  ListSearchItem,
  Tabs,
  TabsPane
}

// 导出 按需引用
export {
  // 页面级组件
  PaasList,
  PaasDetail,
  PaasEdit,

  // 业务组件
  CurrencyText,
  SyRegion,
  SyFile,
  SyImage,
  Currency,
  Number,
  BudgetSubjectTreeSelector,
  PurLineTypeEdit,
  PurLineTypeDetail,
  ReassignmentDialog,
  TaxRate,
  Unit,
  RegionTreeCascade,
  StepImport,
  SyImport,
  TinymceEditorExtend,
  // 基础组件
  SyPopup,
  SyLink,
  ReadText,
  Tip,
  Tabs,
  TabsPane,
  ButtonGallery,
  ButtonGroup,
  Buttons,
  SyForm,
  SyFormItem,
  Tree,
  TreeSelector,

  // 导入导出方法
  SyPaasImport,
  exportPower,

  // 需求提报相关组件
  DemandDialogDetail,
  DemandPageDetail,
  DemandDetailForTable,
  DemandDialogEdit,
  DemandPageEdit,
  DemandPurchaseCategoryConfirm,

  LayoutTab
}

// 导出注册全局
export default {
  install: function (Vue) {
    // 注册全局组件
    for (let k in components) {
      if (!components.hasOwnProperty(k)) {
        continue
      }

      Vue.component(k, components[k])
    }

    PaasComs.install(Vue)

    // 自定义全局方法
    // Vue.prototype.$PaasListPopup =
  }
}
